<template lang="pug">
  .main-item
    template(v-if="source.ptype === 20")
      league(:source="source" :key="source.id")
    template(v-if="source.ptype === 30")
      //- small {{ source }}
      template(v-if="menuX && mmoMode")
        matchX(:source="source" :index="index")
      template(v-else)
        match(:source="source" :index="index")
</template>

<script>
import league from '@/components/mobile/main/league';
import match from '@/components/mobile/main/match';
import matchX from '@/components/mobile/main/matchX';

export default {
  name: 'MainItem',
  components: {
    league,
    match,
    matchX
  },
  props: {
    index: {
      type: Number,
      required: true
    },
    source: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  computed: {
    menuX() {
      return this.$store.getters.menuX;
    },
    mmoMode() {
      return this.$store.getters.mmoMode;
    }
  }
};
</script>
